import Layout from "@/layout";

export default {
  path: "/load",
  component: Layout,
  meta: { title: "Loads", icon: "loads-v2" },
  name: 'dispatchLoadsLayout',
  children: [
    {
      path: "",
      name: "dispatchLoads",
      meta: { title: "My Loads", system: 'dispatch' },
    },
    {
      path: "loadTemplates",
      name: "dispatchLoadTemplates",
      meta: { title: "Load Templates", system: 'dispatch' },
    },
    {
      path: "schedule",
      name: "schedule",
      // component: () => import(/* webpackChunkName: "schedule" */ "@/views/schedule/index"),
      meta: { title: "Fleet Schedule", }
    },
    // {
    //   path: "search-loads",
    //   component: () => import("@/views/search-loads"),
    //   name: "searchLoads",
    //   meta: { title: "Search Loads" }
    // },
    {
      path: "details",
      name: "dispatchDetail",
      component: () => import(/* webpackChunkName: "dispatch-loads" */ "@/views/dispatchs-v2"),
      meta: { title: "details", system: 'dispatch' },
      hidden: true
    },
    {
      path: "edit/load",
      name: "dispatchEdit",
      meta: { activeMenu: 'load', system: 'dispatch'},
      hidden: true
    },
    {
      path: "create/load",
      name: "dispatchLoadAdd",
      meta: { activeMenu: 'load', system: 'dispatch'},
      hidden: true
    },
  ]
}
